import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

/**
 * Representa la información clientCheckResult
 */
class ClientCheckResultDto {
}

/**
 * Servicio encargado de administrar la información del consumo de web service para envíos de mensajes de texto y correo electrónico
 */
class CcmApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see CcmApiService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'send-ccm', 'Ccm');
    }
    /**
     * Consulta el web service de CCM para el envío SMS
     * @param data Información de la solicitud del SMS
     */
    sendCcm(data) {
        return this.getUri(uri => this.httpClient.post(`${uri}/SendCcm`, data));
    }
    /**
   * Consulta el web service de CCM para el envío SMS para aplicaciones externas
   * @param data Información serializada y encriptada de la solicitud del SMS
   */
    sendCcmExternal(data) {
        return this.getUri(uri => this.httpClient.post(`${uri}/SendCcmExternal`, data));
    }
}
CcmApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CcmApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
CcmApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CcmApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: CcmApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of ws-ccm
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CcmApiService, ClientCheckResultDto };
